import React from 'react';
import {ReactComponent as BogoIco} from "../../../../../images/icons/bogo-outline.svg";
import {
    ReactComponent as FoggyBackgroundIco
} from "../../../../../images/backgrounds/promotion/promotion-foggy-background.svg";
import {ReactComponent as EllipseIco} from "../../../../../images/backgrounds/promotion/promotion-ellipse.svg";

interface Props {
    promotion: any;
    singleItem: boolean;
    setPromotionToShow: React.Dispatch<React.SetStateAction<any>>;
}

const MenuPromotionItem = ({promotion, singleItem, setPromotionToShow}: Props) => {
    return (
        <button
            className={`btn btn-promotion ${singleItem ? "single" : ""}`}
            onClick={() => setPromotionToShow(promotion)}>
            <EllipseIco className="ellipse-ico ellipse-ico-left"/>
            <EllipseIco className="ellipse-ico ellipse-ico-right"/>
            <FoggyBackgroundIco className="foggy-ico keep-original-color"/>
            <BogoIco className="promotion-ico"/>
            <p className="mb-0">
                {promotion.name}
            </p>
        </button>
    )
}

export default MenuPromotionItem;